export default "__VITE_ASSET__BLkgAoxQ__"